// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.speakerDivWrapper {
  width: 100%;
  padding: 24px;
  display: flex;
  justify-content: flex-end;
  z-index: 1;
  position: fixed;
  top: 0;
}

.speakerDiv {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.speakerDiv.Active {
  border-radius: 23px;
  background-color: var(--active-speaker-div);
  padding-left: 16px;
}`, "",{"version":3,"sources":["webpack://./src/Core/Components/Guide/Guide.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,eAAe;EACf,MAAM;AACR;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB","sourcesContent":["\n.speakerDivWrapper {\n  width: 100%;\n  padding: 24px;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 1;\n  position: fixed;\n  top: 0;\n}\n\n.speakerDiv {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.speakerDiv.Active {\n  border-radius: 23px;\n  background-color: var(--active-speaker-div);\n  padding-left: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
